/**
 * Creates a debounced function that delays invoking func until after wait milliseconds
 * have elapsed since the last time the debounced function was invoked.
 *
 * @param {Function} cb - The function to debounce
 * @param {number} waitMs - The number of milliseconds to delay
 * @returns {Function & {cancel: Function}} A debounced function with a cancel method
 */
export const debounce = (cb, waitMs) => {
  let timeoutId = null;

  function debounced(...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => cb.apply(this, args), waitMs);
  }

  debounced.cancel = () => {
    clearTimeout(timeoutId);
    timeoutId = null;
  };

  return debounced;
};
